export default __webpack_public_path__ + "static/media/fatherDaughter.06239f90.jpg";